import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [isLoggedIn, setIsLoggedIn] = useState(
    JSON.parse(localStorage.getItem('isLoggedIn')) || false
  );
  const [isSuperuser, setIsSuperuser] = useState(
    JSON.parse(localStorage.getItem('isSuperuser')) || false
  );
  const [isStaff, setIsStaff] = useState(
    JSON.parse(localStorage.getItem('isStaff')) || false
  );
  const [userId, setUserId] = useState(
    JSON.parse(localStorage.getItem('userId')) || false
  );

  useEffect(() => {
    localStorage.setItem('isLoggedIn', isLoggedIn);
    localStorage.setItem('isSuperuser', isSuperuser);
    localStorage.setItem('isStaff', isStaff);
    localStorage.setItem('userId', userId);
  }, [isLoggedIn, isSuperuser, isStaff, userId]);

  const logout = () => {
    setIsLoggedIn(false);
    setIsSuperuser(false);
    setIsStaff(false);
    setUserId(false)
    localStorage.removeItem('isLoggedIn');
    localStorage.removeItem('isSuperuser');
    localStorage.removeItem('isStaff');
    localStorage.removeItem('userId');
  };

  const value = {
    isLoggedIn,
    setIsLoggedIn,
    isSuperuser,
    setIsSuperuser,
    isStaff,
    setIsStaff,
    userId,
    setUserId,
    logout,
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}
